import React from 'react';
import { Segment } from '../../../components/segment';
import { CurrentTicket } from './current-ticket';
import { QueueActions } from './queue-actions';
import styled from 'styled-components';
import { BoothTicket } from '../../../types/ticket';

const Container = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, auto));
  gap: 1em;
  align-items: center;
`;
const Content = styled.section`
  grid-column: 1;
`;
const Actions = styled.section`
  grid-column-end: -1;
`;

export interface TicketHeaderPanelProps {
  currentTicket: BoothTicket | null;
  previousTickets: Array<BoothTicket>;
}

export function TicketHeaderPanel(props: TicketHeaderPanelProps) {
  return (
    <Segment>
      <Container>
        <Content>
          <CurrentTicket
            ticket={props.currentTicket}
            previousTickets={props.previousTickets}
          />
        </Content>
        <Actions>
          <QueueActions />
        </Actions>
      </Container>
    </Segment>
  );
}
